// extracted by mini-css-extract-plugin
module.exports = {"menu_divider":"menu-divider_menu_divider__Ai5nF"};